import { render, staticRenderFns } from "./Sdrz.vue?vue&type=template&id=7bda8ad5&scoped=true&"
import script from "./Sdrz.vue?vue&type=script&lang=js&"
export * from "./Sdrz.vue?vue&type=script&lang=js&"
import style0 from "./Sdrz.vue?vue&type=style&index=0&id=7bda8ad5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda8ad5",
  null
  
)

export default component.exports